import axios from 'axios';
import msalInstance from 'src/utility/msal';
import { loginRequest } from 'src/assets/config/authConfig';
import { isValidAccessToken, setCrewPayApiSession, crewPayKey, timerLogout, isValidIdToken } from '../jwt';
import { SilentRequest } from '@azure/msal-browser';
import { handleError } from '../utils';

const axiosConfig = {
  baseURL: window.crewPayConfig.crewPayBaseUrl,
    validateStatus: function (status) {
    return status >= 200 && status < 400
  }
};

const axiosInstance = axios.create(axiosConfig);

axiosInstance.interceptors.request.use(
  async config => {
    let token = localStorage.getItem(crewPayKey);
    if (token && isValidAccessToken(token)) {
      timerLogout();
    } else {
      try {
        const activeAccount = msalInstance.getActiveAccount();
        if (activeAccount && isValidIdToken(activeAccount)) {
          const accessTokenRequest = { scopes: loginRequest.scopes, account: activeAccount } as SilentRequest;
          const response = await msalInstance.acquireTokenSilent(accessTokenRequest);
          token = response.accessToken;
          setCrewPayApiSession(token);
        } else {
          msalInstance.loginRedirect(loginRequest);
        }
      } catch (error) {
        handleError(error);
      }
    }

    config.headers = {
      'Authorization': `Bearer ${token}`,
      'Accept': config?.headers?.Accept ?? 'application/json',
      'Content-Type': config?.headers?.ContentType ?? 'application/json',
    }
    return config;
  },
  error => {
    Promise.reject(error)
  });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export default axiosInstance;
